var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.09949H4C2.897 4.09949 2 4.98798 2 6.08053V17.9668C2 19.0593 2.897 19.9478 4 19.9478H20C21.103 19.9478 22 19.0593 22 17.9668V6.08053C22 4.98798 21.103 4.09949 20 4.09949ZM20 6.08053V6.58669L12 12.7507L4 6.58768V6.08053H20ZM4 17.9668V9.09568L11.386 14.7862C11.5611 14.9225 11.7773 14.9965 12 14.9965C12.2227 14.9965 12.4389 14.9225 12.614 14.7862L20 9.09568L20.002 17.9668H4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmail);
export default __webpack_public_path__ + "static/media/ic_email.f388e5f0d55c19e3a7b4af658ba96f62.svg";
export { ForwardRef as ReactComponent };